"use client";

import styled from "styled-components";

interface StatusProps {
  $type: "danger" | "success" | "info";
}

const getStatusColor = (color: "danger" | "success" | "info"): string => {
  switch (color) {
    case "danger":
      return `
                color: var(--red);
                background: var(--lightRed);
            `;
    case "success":
      return `
                color: var(--green);
                background: var(--lightGreen);
            `;
    case "info":
      return `
                color: var(--orangeAndWhite);
                background: var(--softOrange);
            `;
  }
};

export const BoxStatus = styled.div<StatusProps>`
  font-family: "Inter Normal";
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 50px;
  width: fit-content;
  ${({ $type }) => getStatusColor($type)}
`;
